import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; //エンドポイント

const config = {
  timeout: 30000,
  method: null, // POSTメソッドを設定
  url: '',
  data: null,
  withCredentials: true,
};

export default {
  addProperty: (
    tableId,
    propertyName,
    propertyType,
    isRequired,
    authUserId,
    sessionKey,
    staffName,
    selectionData
  ) => {
    config.url = baseUrl + "/api/property/add";
    config.method = "post";

    config.data = {
      tableId,
      propertyName,
      propertyType,
      isRequired,
      authInfo: {
        authUserId,
        sessionKey
      },
      staffName,
      selectionData
    };

    return axios.request(config)
      .then(res => { return res; })
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー発生時
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラーメッセージ
          }
        } else {
          ErrMsg = err.message; // その他のエラーメッセージ
        }
        return ErrMsg; // エラーメッセージを返す
      });
  },

  deleteProperty: (
    tableId,
    propertyId,
    authUserId,
    sessionKey,
    staffName,
  ) => {
    config.url = baseUrl + "/api/property/delete";
    config.method = "post";

    config.data = {
      tableId,
      propertyId,
      authInfo: {
        authUserId,
        sessionKey
      },
      staffName
    };

    return axios.request(config)
      .then(res => { return res; })
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー発生時
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラーメッセージ
          }
        } else {
          ErrMsg = err.message; // その他のエラーメッセージ
        }
        return ErrMsg; // エラーメッセージを返す
      });
  },

  editProperty: (
    authUserId,
    sessionKey,
    propertyId,
    propertyName,
    staffName
  ) => {
    config.url = baseUrl + "/api/property/edit";
    config.method = "post";

    config.data = {
      authInfo: {
        authUserId,
        sessionKey,
      },
      propertyId,
      propertyName,
      staffName
    };

    return axios.request(config)
      .then(res => { return res; })
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー発生時
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラーメッセージ
          }
        } else {
          ErrMsg = err.message; // その他のエラーメッセージ
        }
        return ErrMsg; // エラーメッセージを返す
      });
  },
}